/* DACKS GWP QTY CONSOLIDATION TEST - 15 OCT 2026
 * Preview-theme only.
 * Consolidates duplicate paid DACKS cart-drawer rows for the same variant into
 * one logical row while leaving Shopify's underlying BXGY cart lines untouched.
 */
(function () {
  'use strict';

  if (window.__DACKS_GWP_QTY_CONSOLIDATION__) return;
  window.__DACKS_GWP_QTY_CONSOLIDATION__ = true;

  function normaliseText(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function normaliseUrl(value) {
    try {
      var url = new URL(value || '', window.location.origin);
      return url.pathname + url.search;
    } catch (error) {
      return value || '';
    }
  }

  function quantityInput(row) {
    return row.querySelector('.quantity-selector__value');
  }

  function underlyingQuantity(row) {
    var input = quantityInput(row);
    if (!input) return 0;

    var raw = input.getAttribute('data-current-value');
    var quantity = parseInt(raw != null ? raw : input.value, 10);
    return isNaN(quantity) ? 0 : quantity;
  }

  function parseMoney(text) {
    var match = normaliseText(text).match(/(-?[0-9][0-9,]*\.?[0-9]{0,2})/);
    if (!match) return null;

    var value = parseFloat(match[1].replace(/,/g, ''));
    return isNaN(value) ? null : value;
  }

  function resetRows(drawer) {
    Array.prototype.forEach.call(drawer.querySelectorAll('.mini-cart__line-item'), function (row) {
      row.style.display = '';
      row.style.opacity = '';
      row.style.pointerEvents = '';
      row.removeAttribute('aria-hidden');
      row.removeAttribute('data-dacks-consolidated-primary');
      row.removeAttribute('data-dacks-consolidated-hidden');
      row.removeAttribute('data-dacks-group-url');

      var input = quantityInput(row);
      if (input) {
        var current = input.getAttribute('data-current-value');
        if (current != null) input.value = current;
        input.readOnly = false;
        input.removeAttribute('data-dacks-display-total');
      }

      var priceList = row.querySelector('.mini-cart__price-list');
      if (priceList && priceList.hasAttribute('data-dacks-original-price-html')) {
        priceList.innerHTML = priceList.getAttribute('data-dacks-original-price-html');
        priceList.removeAttribute('data-dacks-original-price-html');
      }
    });
  }

  function consolidatePrice(group, primary) {
    var total = 0;
    var hasDollar = false;

    for (var i = 0; i < group.length; i++) {
      var list = group[i].querySelector('.mini-cart__price-list');
      if (!list) return;

      var prices = list.querySelectorAll('.price');
      if (prices.length !== 1 || list.querySelector('.price--compare')) return;

      var text = normaliseText(prices[0].textContent);
      var amount = parseMoney(text);
      if (amount == null) return;

      total += amount;
      if (text.indexOf('$') !== -1) hasDollar = true;
    }

    var primaryList = primary.querySelector('.mini-cart__price-list');
    var primaryPrice = primaryList ? primaryList.querySelector('.price') : null;
    if (!primaryList || !primaryPrice) return;

    primaryList.setAttribute('data-dacks-original-price-html', primaryList.innerHTML);
    primaryPrice.textContent = (hasDollar ? '$' : '') + total.toFixed(2);
  }

  function consolidateDrawer() {
    var drawer = document.getElementById('mini-cart');
    if (!drawer || !drawer.classList.contains('cart-drawer')) return;

    resetRows(drawer);

    var groups = {};

    Array.prototype.forEach.call(drawer.querySelectorAll('.mini-cart__line-item'), function (row) {
      var link = row.querySelector('.mini-cart__product-title');
      var input = quantityInput(row);

      // Gift lines in this theme do not have quantity controls, so the free
      // washbag is deliberately excluded from consolidation.
      if (!link || !input) return;

      var title = normaliseText(link.textContent);
      if (title.toLowerCase().indexOf('dacks') === -1) return;

      var properties = row.querySelector('.mini-cart__property-list');
      var plan = row.querySelector('.mini-cart__plan-allocation');

      var signature = [
        normaliseUrl(link.getAttribute('href')),
        normaliseText(properties ? properties.textContent : ''),
        normaliseText(plan ? plan.textContent : '')
      ].join('|');

      if (!groups[signature]) groups[signature] = [];
      groups[signature].push(row);
    });

    Object.keys(groups).forEach(function (signature) {
      var group = groups[signature];
      if (group.length < 2) return;

      var primary = group[0];
      var input = quantityInput(primary);
      var link = primary.querySelector('.mini-cart__product-title');
      if (!input || !link) return;

      var totalQuantity = group.reduce(function (sum, row) {
        return sum + underlyingQuantity(row);
      }, 0);

      if (totalQuantity < 1) return;

      // Display the combined quantity while keeping the primary row's native
      // Shopify data-current-value/data-line intact. This means the existing
      // +/- buttons still change the underlying cart one unit at a time.
      input.value = totalQuantity;
      input.readOnly = true;
      input.setAttribute('data-dacks-display-total', String(totalQuantity));

      primary.setAttribute('data-dacks-consolidated-primary', 'true');
      primary.setAttribute('data-dacks-group-url', normaliseUrl(link.getAttribute('href')));

      consolidatePrice(group, primary);

      for (var i = 1; i < group.length; i++) {
        group[i].style.display = 'none';
        group[i].setAttribute('aria-hidden', 'true');
        group[i].setAttribute('data-dacks-consolidated-hidden', 'true');
      }
    });
  }

  function removeWholeGroup(row) {
    var groupUrl = row.getAttribute('data-dacks-group-url');
    if (!groupUrl) return;

    row.style.opacity = '0.55';
    row.style.pointerEvents = 'none';

    fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to read cart');
        return response.json();
      })
      .then(function (cart) {
        var updates = {};

        (cart.items || []).forEach(function (item) {
          var title = (item.product_title || item.title || '').toLowerCase();
          if (title.indexOf('dacks') === -1) return;
          if (normaliseUrl(item.url) !== groupUrl) return;
          updates[item.key] = 0;
        });

        if (!Object.keys(updates).length) throw new Error('No matching DACKS cart lines');

        return fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ updates: updates })
        });
      })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to update cart');
        return response.json();
      })
      .then(function () {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: { scrollToTop: false }
        }));
      })
      .catch(function () {
        row.style.opacity = '';
        row.style.pointerEvents = '';
      });
  }

  // A grouped Remove action should remove all underlying split lines for that
  // exact DACKS variant, not just one invisible Shopify line.
  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;

    var remove = event.target.closest('.mini-cart__quantity-remove');
    if (!remove) return;

    var row = remove.closest('[data-dacks-consolidated-primary="true"]');
    if (!row) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    removeWholeGroup(row);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', consolidateDrawer);
  } else {
    consolidateDrawer();
  }

  // Warehouse re-renders the drawer's innerHTML after every cart change.
  // Re-apply the visual grouping against the new server-rendered rows.
  var cartActionItem = document.querySelector('.header__action-item--cart');
  if (cartActionItem) {
    cartActionItem.addEventListener('cart:rerendered', function () {
      window.setTimeout(consolidateDrawer, 0);
    });
  }
})();
